import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import Header from '../containers/Header';
import Login from '../containers/Login';
import Footer from './common/Footer';
import Routes from './Routes';
import Auth from '../containers/Auth';
import 'element-theme-default';
import '../css/admin.css';

interface AppProps extends React.Props<{}> {
  user: any;
  auth: any;
  authActions: any;
}

export default class App extends React.Component<AppProps, {}> {
  static propTypes = {
    user: PropTypes.any,
    auth: PropTypes.any,
    authActions: PropTypes.any.isRequired
  };

  componentWillMount() {
    this.props.authActions.getSession();
  }

  componentDidUpdate() {
    if (this.props.auth.isSignedOut) {
      setTimeout(() => (window.location.href = '/'), 1000);
    }
  }

  render() {
    return (
      <BrowserRouter>
        <div className="fit">
          <Header />
          <div id="wrapper">
            <div className="contentIn">
              <Switch>
                <Route exact={true} path="/" component={Login} />
                <Auth>
                  <Route path="/" component={Routes} />
                </Auth>
              </Switch>
              <Footer />
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.tsx